import PageKey from 'config/PageKey';

export const translationUrlMapping = {
  common: 'shared-content', // TODO: fill with data corresponding your umbraco structure
  [PageKey.MyAccount]: 'useraccountapp/myaccounthome',
  [PageKey.AgentQuickSearch]: 'useraccountapp/agentquicksearch',
};
